import styled from 'styled-components'
import { darken } from 'polished'

import Color from 'helpers/Color'

const Button = styled.button`
  display: ${({ fluid }) => fluid ? 'block' : 'inline-block'};
  font-size: ${({ big }) => big ? '1.3em' : '1em'};
  background-color: ${({color}) => color || Color.green};
  color: ${Color.white};
  border-radius: 20px;
  padding: ${({ compact }) => compact ? '2px 8px' : '5px 15px'};
  cursor: pointer;
  text-align: center;
  margin: auto;
  border: none;
  outline: none;
  width: ${({ fluid }) => fluid ? '100%' : 'auto'};
  float: ${({ right }) => right ? 'right' : 'none'};

  ${({disabled}) => disabled && `
    background-color: ${Color.lightGreen};
    pointer-events: none;
  `}

  &:hover {
    background-color: ${({ color }) => darken(0.05, color || Color.green)};
  }

  &:active {
    background-color: ${({ color }) => darken(0.1, color || Color.green)};
  }
`
export default Button



// WEBPACK FOOTER //
// ./src/components/UI/Button.jsx